export default __webpack_public_path__ + "static/media/discord_grey.ff95aa30.svg";